<script setup lang="ts">
defineProps<{
  description: string
  details?: string
  title: string
}>()
</script>

<template>
  <header class="flex flex-col gap-4 border-b border-(--dash-line) pb-5 md:flex-row md:items-end md:justify-between">
    <div class="min-w-0">
      <p class="dashboard-label">Network dashboard</p>
      <h1 class="mt-2 text-2xl font-medium text-(--dash-ink) md:text-3xl">{{ title }}</h1>
      <p class="mt-2 max-w-3xl text-sm leading-6 text-(--dash-muted)">{{ description }}</p>
    </div>
    <div v-if="$slots.actions" class="flex shrink-0 flex-wrap items-center gap-2">
      <slot name="actions" />
    </div>
  </header>
</template>
